import { useQuery } from '@hooks/reactQuery';

import { getAssetRentCard } from '@api/assetsRent';

import { extractQueryParams } from '@utils/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';

export interface IUseAssetRentRequestCard {
	isLoading: boolean;
	request: any;
	reFetchRequestCard: () => void;
}

export const useQueryAssetRentCard = (id?: string): IUseAssetRentRequestCard => {
	const {
		data,
		isLoading: isLoadingAssetRentCardItems,
		isFetching: isFetchingAssetRentCardItems,
		refetch: reFetchRequestCard,
	} = useQuery({
		queryKey: [
			ASSET_RENT_REQUEST_CARD,
			id,
		],
		queryFn: extractQueryParams(getAssetRentCard),
		enabled: [id],
		refetchOnWindowFocus: false,
	});

	return {
		request: data,
		isLoading: isLoadingAssetRentCardItems || isFetchingAssetRentCardItems,
		reFetchRequestCard,
	};
};
